import UITag from 'UIComponents/tag/UITag';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ApprovalStatus } from '../../types';
import { jsx as _jsx } from "react/jsx-runtime";
function StatusTagI18n(props) {
  const {
    approvalStatus,
    longform
  } = props;
  switch (approvalStatus) {
    case ApprovalStatus.APPROVED:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalStatusTag.APPROVED"
      });
    case ApprovalStatus.CANCELLED:
      return longform ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalStatusTag.CANCELLED-longform"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalStatusTag.CANCELLED"
      });
    case ApprovalStatus.APPROVAL_PENDING:
      return longform ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalStatusTag.APPROVAL_PENDING-longform"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalStatusTag.APPROVAL_PENDING"
      });
    case ApprovalStatus.REJECTED:
      return longform ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalStatusTag.REJECTED-longform"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalStatusTag.REJECTED"
      });
    default:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalStatusTag.default"
      });
  }
}
const getTagUse = approvalStatus => {
  switch (approvalStatus) {
    case ApprovalStatus.APPROVED:
      return 'published';
    case ApprovalStatus.CANCELLED:
      return 'removed';
    case ApprovalStatus.APPROVAL_PENDING:
      return 'inReview';
    default:
      return 'default';
  }
};
function ApprovalStatusTag(props) {
  const tagUse = getTagUse(props.approvalStatus);
  return /*#__PURE__*/_jsx(UITag, {
    use: tagUse,
    children: /*#__PURE__*/_jsx(StatusTagI18n, Object.assign({}, props))
  });
}
export default ApprovalStatusTag;